import http from "../../services/http";
const path = "api/paragraphs";

const changeParents = ({ onSuccess, onError, onEnd, body, id = 0 }) => {
    return async(dispatch, getState) => {
        try {
            const store = getState();
            const res = await http.put({
                url: path + `/changeparents/${id}`,
                headers: {
                    "x-auth-token": store.auth.token
                },
                body
            });
            if (onSuccess) onSuccess(res);
        } catch (error) {
            if (onError) onError(error);
        } finally {
            if (onEnd) onEnd();
        }
    };
};
export { changeParents };